<template>
    <el-dialog :title="title" :visible.sync="dialogFormVisible" @close="close" :close-on-click-modal="false" :close-on-press-escape="false" width="900px">
        <el-form size="small" :model="form" :rules="formRules" :label-width="formLabelWidth" ref="form">

            <el-form-item label="类型" prop="activity_type">
                <el-radio-group v-model="form.activity_type" @change="handleTypeChange">
                    <el-radio :label="1" :disabled="form.activity_id!==0">线上活动</el-radio>
                    <el-radio :label="2" :disabled="form.activity_id!==0">线下活动</el-radio>
                </el-radio-group>
            </el-form-item>

            <el-form-item label="标题" prop="title">
                <el-input v-model="form.title" placeholder="标题" clearable/>
            </el-form-item>

            <el-form-item label="封面" prop="image_id">
                <el-row>
                    <el-button type="primary" @click="openUpload('image', 'thumb')">选择图片</el-button>
                    <div v-if="form.image_id !== ''" class="img">
                        <el-image
                                style="height: 100px"
                                :src="form.file_path"
                                fit="contain"></el-image>
<!--                        <img :src="form.file_path" height="100" />-->
                    </div>
                </el-row>
            </el-form-item>

            <el-form-item :label="form.activity_type === 1 ? '截止投稿时间' : '活动举办时间'" prop="activity_time">
                <div class="block">
                    <span class="demonstration"></span>
                    <el-date-picker
                            v-model="form.activity_time"
                            type="datetime"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            default-time="23:59:59"
                            placeholder="选择日期时间">
                    </el-date-picker>
                </div>
            </el-form-item>

            <el-form-item label="活动地点" prop="activity_address" v-if="form.activity_type === 2">
                <el-input v-model="form.activity_address" placeholder="活动地点" clearable/>
            </el-form-item>

            <el-form-item :label="form.activity_type === 1 ? '评选时间' : '报名截止时间'">
                <div class="block">
                    <span class="demonstration"></span>
                    <el-date-picker
                            size="small"
                            v-model="form.active_start_end_time"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :default-time="['00:00:00', '23:59:59']"
                    >
                    </el-date-picker>
                </div>
                <div class="tips" v-if="form.activity_type === 1">如同步到评选投票,评选时间就是投票时间</div>
            </el-form-item>

            <el-form-item label="获奖公布时间" prop="publish_time" v-if="form.activity_type === 1">
                <div class="block">
                    <span class="demonstration"></span>
                    <el-date-picker
                            v-model="form.publish_time"
                            type="datetime"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            default-time="23:59:59"
                            placeholder="选择日期时间">
                    </el-date-picker>
                </div>
            </el-form-item>

            <el-form-item label="附件" v-if="form.activity_type === 1">
                <el-row>
                    <div class="draggable-list">
                        <div class="item img-select" v-if="form.file_id===0" @click="openUpload('file', 'file')"><i class="el-icon-plus"></i></div>
                        <div v-if="form.file_id>0">
                            {{ form.file.file_name }}
                            <div>
                                <el-button icon="el-icon-picture-outline" @click="delFile">删除附件</el-button>
                            </div>
                        </div>
                    </div>
                </el-row>
            </el-form-item>

            <el-form-item label="虚拟参与数" prop="title">
                <el-input v-model.number="form.set_enroll_num" placeholder="虚拟参与数" clearable/>
            </el-form-item>

            <el-form-item label="活动类别"></el-form-item>
            <el-form-item
                    v-for="(item, index) in form.activity_fields.category"
                    :label="'类别' + (index + 1).toString()"
                    :key="item.key"
                    :prop="'activity_fields.category.' + index + '.name'"
                    :rules="{required: true, message: '字段不能为空', trigger: 'blur'}"
            >
                <el-input v-model="item.name" style="width: 200px" ></el-input><el-button @click.prevent="removeField(item)">删除</el-button>
            </el-form-item>

            <el-form-item>
                <el-button @click="addField">新增类别</el-button>
            </el-form-item>

            <el-form-item v-if="form.activity_fields.category" label="类型"
                          v-for="(item, index) in form.activity_fields.category"
                          :label="item.name"
                          :key="'type'+index.toString()"
            >
                <el-tag :key="index.toString() + item_index.toString()"
                        v-for="(item_value, item_index) in form.activity_fields.category[index].fields"
                        closable
                        :disable-transitions="false"
                        @close="handleClose(index, item_index)">
                    {{item_value.name}}
                </el-tag>
                <el-button type="success" class="button-new-tag" size="small" @click="showInput(index)">+ 新增类别字段</el-button>
            </el-form-item>

            <el-form-item label="同步到评选投票" v-if="form.activity_type === 1">
                <el-radio-group v-model="form.is_vote">
                    <el-radio :label="1" :disabled="form.activity_id!==0">是</el-radio>
                    <el-radio :label="0" :disabled="form.activity_id!==0">否</el-radio>
                </el-radio-group>
            </el-form-item>

            <el-form-item label="投票次数" prop="user_max_num" v-if="form.is_vote === 1">
                <el-input v-model.number="form.user_max_num" autocomplete="off" :disabled="form.activity_id!==0"></el-input>
                <div class="tips">每个微信号每天可以投票次数.</div>
            </el-form-item>

            <el-form-item label="同一选手投票次数" prop="cmpe_max_num" v-if="form.is_vote === 1">
                <el-input v-model.number="form.cmpe_max_num" autocomplete="off" :disabled="form.activity_id!==0"></el-input>
                <div class="tips">每个微信号每天可为同一选手投票次数.</div>
            </el-form-item>

            <el-form-item label="内容" prop="content">
                <Editor :text="form.content" @get-content="contentChangeFunc" :width="600" ></Editor>
            </el-form-item>

            <el-form-item label="状态">
                <el-radio-group v-model="form.is_show">
                    <el-radio :label="1">显示</el-radio>
                    <el-radio :label="0">隐藏</el-radio>
                </el-radio-group>
            </el-form-item>

            <el-form-item label="排序" prop="sort">
                <el-input v-model.number="form.sort" autocomplete="off"></el-input>
                <div class="tips">越小越靠前</div>
            </el-form-item>

        </el-form>

        <div slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="save" :disabled="submit_loading">确 定</el-button>
        </div>

        <!--上传图片组件-->
        <Upload v-if="isupload" :config.sync="file_config" :isupload="isupload" @returnImgs="returnImgsFunc">上传图片</Upload>
    </el-dialog>
</template>

<script>
    import { activityEdit, activityDetail, getSetting } from '@/api/education'
    import Upload from '@/components/file/Upload'
    import Editor from '@/components/tsk/editor'

    export default {
        components: { Upload, Editor },
        data() {
            return {
                title: '',
                form: {
                    activity_id: 0,
                    title: '',
                    activity_type: 1,
                    image_id: '',
                    file_path: '',
                    activity_time: '',
                    activity_address: '',
                    active_start_end_time: [],
                    publish_time: '',
                    file_id: 0,
                    file:[],
                    is_vote: 0,
                    content: '',
                    sort: 1,
                    is_show: 1,
                    user_max_num: 1,
                    cmpe_max_num: 1,
                    activity_fields: {
                        category: []
                    },
                    set_enroll_num: 0,
                },
                /*左边长度*/
                formLabelWidth: '120px',
                /*是否显示*/
                dialogFormVisible: false,
                /*是否正在提交*/
                submit_loading: false,
                /*链接选择*/
                is_linkset: false,
                // 验证
                formRules: {
                    name: [{
                        required: true,
                        message: '请输入标题',
                        trigger: 'blur'
                    }]
                },
                /*上传图片*/
                isupload: false,
                file_name: 'thumb',
                file_config: {},

                key: 'activity_fields',
                fields: [],
                activity_fields: {

                },

            };
        },
        props: ['fetch-data'],
        created() {

        },
        methods: {
            showDialog(row) {
                if (!row) {
                    this.title = '添加活动'
                } else {
                    this.title = '编辑活动'
                    this.form.activity_id = row.activity_id
                    this.getDetail()
                }
                // this.getSet()
                this.dialogFormVisible = true
            },
            // 关闭
            close() {
                this.form = this.$options.data().form
                this.form.content = ''
                this.activity_fields = []
                this.dialogFormVisible = false
            },
            // 保存
            save() {
                this.$refs['form'].validate(async (valid) => {
                    if (valid) {
                        this.submit_loading = true
                        activityEdit(this.form).then((result)=>{
                            this.$message({message: result.msg, type: 'success'});
                            this.$emit('fetch-data')
                            this.submit_loading = false
                            this.close()
                        }).catch(()=>{
                            this.submit_loading = false
                        })
                    }
                })
            },
            getDetail(){
                activityDetail({id: this.form.activity_id}).then((result)=>{
                    this.form = Object.assign({}, result.data)
                    this.form.file = result.data.file
                    if(result.data.is_vote > 0 && result.data.vote){
                        this.form.user_max_num = result.data.vote.user_max_num
                        this.form.cmpe_max_num = result.data.vote.cmpe_max_num
                    }
                    // if(result.data.activity_fields && result.data.activity_fields.category.length > 0){
                    //     // result.data.activity_fields.category.map((item)=>{
                    //     //     this.activity_fields.push(item.name)
                    //     // })
                    //     this.form.values = result.data.activity_fields
                    // }else {
                    //     this.form.values = { category: [] }
                    // }

                })
            },
            handleTypeChange(val){
                this.form.activity_type = val
            },
            contentChangeFunc(val){
                this.form.content = val
            },

            // 图片上传
            openUpload(file_type, file_name) {
                this.file_name = file_name;
                if (file_name === 'thumb') { // 封面图
                    this.file_config = {
                        total: 1,
                        file_type: 'image'
                    };
                }
                if(file_name === 'images'){
                    this.file_config = {
                        total: 9,
                        file_type: 'image'
                    };
                }

                if(file_name === 'video'){
                    this.file_config = {
                        total: 1,
                        file_type: 'video'
                    };
                }

                if(file_name === 'file'){
                    this.file_config = {
                        total: 1,
                        file_type: 'file'
                    };
                }
                this.isupload = true;
            },

            // 获取配置
            // getSet(){
            //     getSetting({key: this.key}).then((result)=>{
            //         if(result.data.values){
            //             this.fields = result.data.values.category
            //             // console.log(this.fields, 'this.fields')
            //         }
            //         this.loading = false;
            //     })
            // },

            /*获取图片*/
            returnImgsFunc(e) {
                if (e === null) {
                    this.isupload = false
                    return
                }
                if (this.file_name === 'thumb') { // 封面图
                    this.form.image_id = e[0].file_id;
                    this.form.file_path = e[0].file_path;
                }
                if (this.file_name === 'images') { // 产品图多张
                    for (let i = 0, e_length = e.length; i < e_length; i++) {
                        if (this.form.images.length >= 9) {
                            this.isupload = false
                            this.$message({message: '最多只能选择9张图片', type: 'error'});
                            return
                        }
                        let is_file = false
                        this.form.images.map((item)=>{
                            if(item.file_id === e[i].file_id){
                                is_file = true
                            }
                        })
                        if(is_file === false){
                            this.form.images.push(e[i])
                        }
                    }
                }
                if (this.file_name === 'video') { // 视频
                    this.form.video_id = e[0].file_id;
                }
                if (this.file_name === 'file') { // 文件
                    this.form.file_id = e[0].file_id;
                    this.form.file = e[0]
                }

                this.isupload = false;
            },

            /*删除文件*/
            deleteImg(index) {
                this.form.images.splice(index, 1);
            },
            delVideo(){
                this.form.video_id = 0;
                this.form.video = [];
            },
            delFile(){
                this.form.file_id = 0;
                this.form.file = [];
            },

            removeField(item) {
                var index = this.form.activity_fields.category.indexOf(item)
                if (index !== -1) {
                    this.form.activity_fields.category.splice(index, 1)
                }
            },
            addField() {
                let length =  this.form.activity_fields.category.length
                this.form.activity_fields.category.push({
                    name: '',
                    key: parseInt(length) + 1,
                    fields: [],
                });
            },
            handleClose(index, tag_index) {
                this.form.activity_fields.category[index].fields.splice(tag_index, 1);
            },
            showInput(index) {
                this.$prompt('请输入字段', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(({ value }) => {
                    this.form.activity_fields.category[index].fields.push({
                        name: value,
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '取消输入'
                    });
                })
            },

        }
    };
</script>

<style scoped>
    .tips {
        color: #ccc;
    }
    .draggable-list {
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
    }
    .draggable-list .wrapper > span {
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
    }

    .draggable-list .item {
        position: relative;
        width: 110px;
        height: 110px;
        margin-top: 10px;
        margin-right: 10px;
        border-radius: 8px;
        overflow: hidden;
        border: 1px solid #dddddd;
    }

    .draggable-list .delete-btn {
        position: absolute;
        top: 0;
        right: 0;
        width: 16px;
        height: 16px;
        background: red;
        line-height: 16px;
        font-size: 16px;
        color: #ffffff;
        display: none;
    }

    .draggable-list .item:hover .delete-btn {
        display: block;
    }

    .draggable-list .item img {
        position: absolute;
        top: 50%;
        left: 50%;
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        max-height: 100%;
        max-width: 100%;
    }

    .draggable-list .img-select {
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px dashed #dddddd;
        font-size: 30px;
    }

    .draggable-list .img-select i {
        color: #409eff;
    }
</style>



// WEBPACK FOOTER //
// src/views/education/activity/activity/edit.vue